import { formatFirstCaseToUpper } from '@anwb/poncho/utilities/formatters';
import { InteriorColor, InteriorColorKey, StandardEquipment } from 'types';

export const getInteriorColorAndFabric = (fabric: string, color: string): string => {
	const interiorColor = InteriorColor[color as InteriorColorKey] || '';
	const separator = fabric && interiorColor ? ' - ' : '';

	return formatFirstCaseToUpper(`${fabric}${separator}${interiorColor}`) || '';
};

export const getInteriorFabricFromEquipment = (standardEquipment: StandardEquipment[]): string =>
	standardEquipment.find((e) => e.schemaId === 17401)?.additionalInfo?.seatMainMaterial || '';
